import * as React from "react";
import { BaseModal } from "../../../atoms/base-modal";
import { useState } from "react";
import apiClient from "../../../../application/apis/tenant-management/tenant-management-client";
import { toast } from "react-toastify";
import { UserEntity } from "../../../../application/domain/user/user-entity";
import { reportUnexpectedError } from "../../../../error-reporter";
import { ConfirmModalContentForUser } from "./confirm-modal-content-for-user";

interface ModalWithInputProps {
  isActive: boolean;
  user: UserEntity;
  onClose: () => void;
  title: string;
}

export const LoginLockResetConfirmModal: React.FC<ModalWithInputProps> = ({
  isActive,
  user,
  onClose,
  title,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const resetLoginLock = React.useCallback(async () => {
    try {
      setIsLoading(true);
      await apiClient.resetLoginLock(user.id);
      toast.success("ロックが解除されました");
      onClose();
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("ログインロックの解除に失敗しました");
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  return (
    <BaseModal isActive={isActive} title={title} onClose={onClose}>
      <ConfirmModalContentForUser
        user={user}
        confirmMessage={
          <h2>以下のアカウントに対してログインロックの解除を行いますか?</h2>
        }
        submitLabel="解除する"
        onSubmit={resetLoginLock}
        cancelLabel="キャンセルする"
        onCancel={onClose}
        isLoading={isLoading}
      />
    </BaseModal>
  );
};
